var _circle, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 67,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5162 66.3846C70.1369 66.3846 73.0721 63.3884 73.0721 59.6923C73.0721 55.9962 70.1369 53 66.5162 53C62.8955 53 59.9603 55.9962 59.9603 59.6923C59.9603 63.3884 62.8955 66.3846 66.5162 66.3846ZM63.619 69H70.3808C74.2229 69 77.5243 71.727 78.2499 75.5L78.321 75.87C78.8588 78.6665 77.0278 81.3694 74.2313 81.9072C73.9104 81.9689 73.5843 82 73.2576 82H60.7422C57.8945 82 55.5859 79.6915 55.5859 76.8438C55.5859 76.517 55.617 76.1909 55.6787 75.87L55.7499 75.5C56.4754 71.727 59.7769 69 63.619 69Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1138_2466",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 53,
    width: 24,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5162 66.3846C70.1369 66.3846 73.0721 63.3884 73.0721 59.6923C73.0721 55.9962 70.1369 53 66.5162 53C62.8955 53 59.9603 55.9962 59.9603 59.6923C59.9603 63.3884 62.8955 66.3846 66.5162 66.3846ZM63.619 69H70.3808C74.2229 69 77.5243 71.727 78.2499 75.5L78.321 75.87C78.8588 78.6665 77.0278 81.3694 74.2313 81.9072C73.9104 81.9689 73.5843 82 73.2576 82H60.7422C57.8945 82 55.5859 79.6915 55.5859 76.8438C55.5859 76.517 55.617 76.1909 55.6787 75.87L55.7499 75.5C56.4754 71.727 59.7769 69 63.619 69Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1138_2466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 53H52V83H82V53Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile1);
export default __webpack_public_path__ + "static/media/profile-1.c22cc3b0cf68cac2a7339d295bb9aace.svg";
export { ForwardRef as ReactComponent };